import {
    IRelatorioResultadoContato,
    ResultadoContatoRequest,
} from "../../../Interfaces/Relatorios/RelatoriosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function RelatorioResultadoContatoService(
    requestBody: ResultadoContatoRequest
) {
    return Service(
        Axios.post<Array<IRelatorioResultadoContato>>(
            `/cobranca/resultadocontato/relatorioresultadocontato`,
            requestBody
        )
    );
}

export async function RelatorioResultadoContatoExportExcelService(
    flExport: boolean,
    requestBody: ResultadoContatoRequest
) {
    return Service(
        Axios.post<Blob>(
            `/cobranca/resultadocontato/relatorioresultadocontato?flExport=${flExport}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}
